




import { Component, Vue } from 'vue-property-decorator'
import DownloadBase from '../../modules/class/Downloads'
import SilverEgg from '../../modules/silverEgg/SilverEgg'

@Component({})
export default class SendPageAccess extends Vue {
  // ---------------------------------------------------------------------------
  // data
  protected se: SilverEgg = new SilverEgg(
    drupalSettings.vueComponent.silveregg.domain,
    drupalSettings.vueComponent.silveregg.specId
  )

  // ---------------------------------------------------------------------------
  // hooks
  private created() {
    // PDFのダウンロードが行われたとき、
    // GTMへシルバーエッグの用のイベントを送信する
    document.addEventListener(
      'start-pdf-download-for-silverEgg',
      (event: CustomEventInit<{ info: DownloadBase }>) => {
        if (event.detail !== undefined) {
          this.se.sendDocumentDlEventToGtm(event.detail.info.url)
        }
      }
    )
  }

  public async mounted() {
    // 行動履歴を送信する場合、アクセス情報をGTMへ送信する
    const sendPageAccess =
      drupalSettings.vueComponent.silveregg.sendPageAccess || false
    if (sendPageAccess) {
      this.se.sendPageAccessEventToGtm()
    }
  }
}
